<template>
<v-app id="inspire">
    <v-content>
    <v-container fluid fill-height>
        <v-layout align-center justify-center style="text-align: center;">
        <v-flex xs12 sm8 md4>
            <h1 class="font-weight-light">Service Scheduler | Admin</h1>
            <v-form>
            <v-layout>
                <v-flex xs12>
                <div id="firebaseui-auth-container"></div>
                </v-flex>
            </v-layout>
            <v-layout class="mt-3">
                <v-flex xs11 offset-xs1>
                <p></p>
                </v-flex>
            </v-layout>
            </v-form>
        </v-flex>
        </v-layout>
    </v-container>
    </v-content>
</v-app>
</template>

<script>
import firebase from "firebase";
import * as firebaseui from "firebaseui";
import { db } from "../main";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
    mounted() {
        console.log(this.$stage)
        let self = this
        let uiConfig = {
        signInOptions: [{
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        }],

        
        callbacks: {
            signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                firebase.auth().onAuthStateChanged(function(user) {
                    if (user) {
                        let googleUser = {
                            uid: user.uid,
                            email: user.email,
                            displayName: user.displayName,
                            photoURL: user.photoURL,
                            staging: self.$stage
                        };
                        
                        self.$store.dispatch("setUser", googleUser).then(() => {
                            user.getIdToken().then(function(accessToken) {
                                self.$store.dispatch("setToken", accessToken).then(() => {
                                    self.$store.dispatch("setAuth", true).then(() => {
                                        self.checkUserAccess()
                                    }).catch(error => console.log(error));	
                                });
                            });
                        });
                    } 
                }, function(error) {
                    console.log(error)
                });
                return false;
            }
        }
        };
        let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
        ui.start("#firebaseui-auth-container", uiConfig);
    },

    methods: {
        checkUserAccess() {
            let self = this
            db.collection("HO-Users"+self.$stage).doc(self.user.email)
            .get().then(function(doc) {
                if(doc.data()) {
                    if(doc.data().status == "active") {
                        window.location.href = "/dashboard"
                        console.log("Active user")
                    } else {
                        window.location.href = "/logout"
                        console.log("Inactive user")
                    }
                } else {
                    window.location.href = "/logout"
                    console.log("Restricted web-site")
                }
            }).catch(function(error) { console.log("Error getting from invitation:", error)})
        }
    },

    computed: {
		...mapGetters(["auth","user"])
    },
    
    beforeDestroy() {
		this.ui.delete()
	}

};
</script>

